/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldChange
 */
export interface FieldChange {
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    formName: string;
}

/**
 * Check if a given object implements the FieldChange interface.
 */
export function instanceOfFieldChange(value: object): value is FieldChange {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if ((!('formName' in (value as Record<string, any>)) && !('form_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['formName'] === undefined && (value as Record<string, any>)['form_name'] === undefined)) return false;
    return true;
}

export function FieldChangeFromJSON(json: any): FieldChange {
    return FieldChangeFromJSONTyped(json, false);
}

export function FieldChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldChange {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'from': json['from'],
        'to': json['to'],
        'formName': json['form_name'],
    };
}

export function FieldChangeToJSON(json: any): FieldChange {
    return FieldChangeToJSONTyped(json, false);
}

export function FieldChangeToJSONTyped(value?: FieldChange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'from': value['from'],
        'to': value['to'],
        'form_name': value['formName'],
    };
}

